const Cancel = ({ styleClass }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" width="16px" height="16px" stroke="currentColor" className={`${styleClass ? styleClass : 'curai-w-6 curai-h-6'}`}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>

  )
}

export default Cancel;